export default __webpack_public_path__ + "static/media/ForensicLedgerLeft.d78476f1.png";